"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {},
        legend: {
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: '10px',
            lineHeight: '12px',
            color: themes_1.materialColors.grey[400],
            // remove default focus primary color
            '&.Mui-focused': {
                color: themes_1.materialColors.grey[400],
            },
        },
        group: {
            // standardize line height
            '& > .MuiBox-root': {
                lineHeight: '20px',
            },
            // reduce the area between choices
            '& .MuiButtonBase-root': {
                paddingTop: '4px',
                paddingBottom: '4px',
            },
        },
    });
});
